import { create } from 'zustand';
import { ConfigurationResponse } from '@utils-global';

interface ConfigurationState {
  configuration: ConfigurationResponse | undefined;
  setConfiguration: (value: ConfigurationResponse | undefined) => void;
}

export const useConfigurationStorage = create<ConfigurationState>()((set) => ({
  configuration: undefined,
  setConfiguration: (value) => set({ configuration: value }),
}));

// v2 switches the app to the new home screen and layouts. False while there is
// no configuration (not loaded yet, or the fetch failed).
export const selectIsV2 = (state: ConfigurationState): boolean =>
  Boolean(state.configuration?.data?.v2);

export const useIsV2 = () => useConfigurationStorage(selectIsV2);
